import React, { useEffect, useState } from "react";
import HeartIcon from "../../../assets/icons/ABHA-icons/heart-icon";
import TickIcon2 from "../../../assets/icons/ABHA-icons/tick2-icon";
import TickIcon3 from "../../../assets/icons/ABHA-icons/tick3-icon";
import GovIcon from "../../../assets/icons/ABHA-icons/gov-icon";
import InputField from "../../forms/input-field";
import { Form, Formik } from "formik";
import errorToast from "../../helper-components/error-toast";
import AddButton from "../../buttons/button";
import * as Yup from "yup";
import { RefreshCw } from "lucide-react";
import { url } from "../../../redux/config";
import { accessTokenAction } from "../../../redux/actions/admin-customer-action";
import axios from "axios";
import successToast from "../../helper-components/success-toast";
import { useDispatch } from "react-redux";
import { handleShowErrorToast } from "../../helper-components/helper-function";
import InputPhoneField from "../../forms/phone-input-field";

function InputPage({
  setAdhaarAccessToken,
  setAdhaarTokenExpiresIn,
  setStatus,
  setTxnId,
  closeModal,
}) {
  const [loading, setLoading] = useState(false);

  const [mathQuestion, setMathQuestion] = useState({
    question: "",
    answer: "",
  });
  const [verificationError, setVerificationError] = useState("");

  const dispatch = useDispatch();

  // Handle ESC key press
  // useEffect(() => {
  //   const handleEscape = (e) => {
  //     if (e.key === "Escape" && findABHApopup) {
  //       closeModal();
  //     }
  //   };

  //   document.addEventListener("keydown", handleEscape);
  //   return () => document.removeEventListener("keydown", handleEscape);
  // }, [findABHApopup]);

  // Prevent body scroll when modal is open

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Generate math question on component mount
  useEffect(() => {
    generateMathQuestion();
  }, []);

  const generateMathQuestion = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    const operators = ["+", "-"];
    const operator = operators[Math.floor(Math.random() * operators.length)];

    let answer;
    let question;

    if (operator === "+") {
      answer = num1 + num2;
      question = `${num1} + ${num2} = ?`;
    } else {
      // For subtraction, ensure positive result
      const larger = Math.max(num1, num2);
      const smaller = Math.min(num1, num2);
      answer = larger - smaller;
      question = `${larger} - ${smaller} = ?`;
    }

    setMathQuestion({ question, answer });
    setVerificationError("");
  };

  const initialValues = {
    mobile: "",
    verification: "",
  };

  const validationSchema = Yup.object().shape({
    mobile: Yup.string()
      .required("Please your 10 digit Mobile number")
      .matches(/^\d{10}$/, "Mobile number must be 10 digits"),

    verification: Yup.string()
      .required("Please solve the math problem")
      .test(
        "math-captcha",
        "Incorrect answer. Please try again.",
        function (value) {
          if (!value) return false;
          const userAnswer = parseInt(value);
          return userAnswer === mathQuestion.answer;
        }
      ),
  });
  const onTokenFail = (data) => {
    setLoading(false);
    errorToast(data.message);
  };
  const getABHA = async (data, mobile) => {
    try {
      const response = await axios.post(
        `${url}/abha-integration/find-abha-using-mobile`,
        {
          accessToken: data,
          mobile: JSON.stringify(mobile),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      successToast("OTP is sent");

      console.log("Response:", response);
      console.log("txnid", response?.data?.data?.abdmResponse?.txnId);
      setAdhaarAccessToken(data);
      setTxnId(response?.data?.data?.abdmResponse?.txnId);
      // setmessage(response?.data?.data?.abdmResponse?.message);
      console.log("--------------------------------", response);
      // setStatus("OTP Verification");
      // setPosition(2);
      setStatus("otp");
      setLoading(false);
      //   setPopUp(true);

      return response.data;
    } catch (error) {
      console.log("hhhhhhhhhhhhhhhh", error?.response?.data);
      errorToast(error?.response?.data?.message);
      console.error(
        "Error sending OTP:",
        error.response?.data || error.message
      );
      setLoading(false);
      // throw error;
    }
  };
  const getAccessToken = async () => {
    try {
      const response = await axios.post(
        `${url}/abha-integration/generate-session-token`,
        {
          clientId: "SBXID_009917",
          clientSecret: "68bd8f02-4c70-405f-850e-9774da34917d",
          grantType: "client_credentials",
        },
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("1111111111111111111111111", response);
      return response?.data?.data?.sessionToken?.accessToken;
    } catch (error) {
      errorToast(error?.response?.data?.message || "Auth failed");
      // errorToast(error);
      throw error;
    }
  };
  const onsave = async (values) => {
    setLoading(true);
    try {
      const token = await getAccessToken();
      await getABHA(token, values.mobile);
    } catch (err) {
      console.error("Onsave error:", err);
      setLoading(false);
    }
  };

  // const onsave = async (values) => {
  //   try {
  //     const response = await axios.post(
  //       `${url}/abha-integration/search-abha-using-mobile`,
  //       {
  //         clientId: "SBXID_009917",
  //         clientSecret: "68bd8f02-4c70-405f-850e-9774da34917d",
  //         grantType: "client_credentials",
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("Response:", response);
  //     successToast("OTP is sent");
  //     setTxnId(response?.data?.data?.abdmResponse?.txnId);
  //     // setmessage(response?.data?.data?.abdmResponse?.message);
  //     console.log("--------------------------------", response);
  //     // setStatus("OTP Verification");
  //     // setPosition(2);

  //     setLoading(false);
  //     //   setPopUp(true);

  //     // response.data;
  //     return response?.data?.sessionToken?.accessToken;
  //   } catch (error) {
  //     console.log("hhhhhhhhhhhhhhhh", error?.response?.data);
  //     errorToast(error?.response?.data?.message);
  //     console.error(
  //       "Error sending OTP:",
  //       error.response?.data || error.message
  //     );
  //     setLoading(false);
  //     // throw error;
  //   }
  // };
  // const onsave = (values) => {
  //   setLoading(true);
  //   // if (captchaVerified == false) return errorToast("Captcha is wrong");
  //   dispatch(
  //     accessTokenAction((data) => {
  //       // setAdhaarNo(values.adhaar);

  //       let token = data?.data?.sessionToken?.accessToken;

  //       setAdhaarAccessToken(data?.data?.sessionToken?.accessToken);
  //       if (token == "" || token == undefined || token == null) {
  //         errorToast("Failed to get AccessToken");
  //       }
  //       setAdhaarTokenExpiresIn(data?.data?.sessionToken?.expiresIn);
  //       getABHA(data?.data?.sessionToken?.accessToken, values.mobile);

  //       // sendOtpWithAadhaar(data?.data?.sessionToken?.accessToken);
  //       // setAccessToken(data?.data?.sessionToken?.accessToken);
  //       // setPopUp(true);
  //       // setLoading(false);
  //     }, onTokenFail)
  //   );
  // };
  // const onsave = (values) => {
  //   // if (verificationError !== "") return errorToast(verificationError);
  //   setLoading(true);
  //   // if (captchaVerified == false) return errorToast("Captcha is wrong");
  //   dispatch(
  //     accessTokenAction(
  //       (data) => {
  //         // setAdhaarNo(values.adhaar);

  //         let token = data?.data?.sessionToken?.accessToken;
  //         setAdhaarAccessToken(data?.data?.sessionToken?.accessToken);
  //         // if (token == "" || token == undefined || token == null) {
  //         //   errorToast("Failed to get AccessToken");
  //         // }
  //         successToast("got token");
  //         console.log("...........................................", data);

  //         setAdhaarTokenExpiresIn(data?.data?.sessionToken?.expiresIn);
  //         getABHA(data?.data?.sessionToken?.accessToken, values.mobile);

  //         // getABHA(data?.data?.sessionToken?.accessToken);
  //         // setAccessToken(data?.data?.sessionToken?.accessToken);
  //         // setPopUp(true);
  //         setLoading(false);
  //       },
  //       (data) => {
  //         console.log("...........................................", data);
  //         setLoading(false);
  //       },
  //       onTokenFail
  //     )
  //   );
  // };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onsave}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => {
        const validateVerification = () => {
          const userAnswer = parseInt(values.verification);
          if (userAnswer === mathQuestion.answer) {
            setVerificationError("");
            // Proceed with ABHA finding logic
            console.log("Verification successful, finding ABHA...");
            return true;
          } else {
            setVerificationError("Incorrect answer. Please try again.");
            generateMathQuestion(); // Generate new question on wrong answer
            setFieldValue("verification", ""); // Clear the input
            return false;
          }
        };

        return (
          <Form className="flex flex-col h-full">
            <div className="flex justify-center items-center w-full h-full ">
              <div className="flex flex-row gap-0 justify-center items-center w-full h-[80%] ">
                {/* {blue} */}
                <div className="flex flex-col w-[430px] rounded-l-2xl h-full  gap-5 p-10 bg-[var(--abha-find-bg)] text-white">
                  {/* {top} */}

                  <div className="flex flex-row  gap-4">
                    <div className="flex flex-row">
                      <div className="flex items-center justify-center w-11 h-[52px] rounded-lg bg-white">
                        <HeartIcon />
                      </div>
                    </div>

                    <div className=" flex flex-col  gap-2 w-full mt-auto ">
                      <label
                        className={`
                 text-[length:var(--abha-method-sub-title-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
                      >
                        ABHA
                      </label>
                      <label
                        className={`text-[var(--abha-card-fg)]
                 text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
                      >
                        Ayushman Bharat Health Account
                      </label>
                    </div>
                  </div>
                  {/* {title} */}

                  <label
                    className={`
                 text-[length:var(--abha-method-bold-fs)] font-[var(--abha-method-title-fw)] leading-[45px] mt-11 `}
                  >
                    Your Digital Health Identity
                  </label>
                  <label
                    className={`text-[var(--abha-card-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-label-fw)] leading-[24px] `}
                  >
                    Create your unique health ID to access healthcare services
                    across India. Secure, portable, and interoperable health
                    records at your fingertips.
                  </label>

                  <div className="flex flex-col gap-4">
                    <div className="flex flex-row gap-4">
                      <TickIcon3 />
                      <label
                        className={`text-[var(--abha-card-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
                      >
                        Unified health records
                      </label>
                    </div>
                    <div className="flex flex-row gap-4">
                      <TickIcon3 />
                      <label
                        className={`text-[var(--abha-card-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
                      >
                        Secure data encryption
                      </label>
                    </div>{" "}
                    <div className="flex flex-row gap-4">
                      <TickIcon3 />
                      <label
                        className={`text-[var(--abha-card-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
                      >
                        Easy healthcare access
                      </label>
                    </div>
                  </div>
                  <div className="flex flex-row gap-4 mt-auto">
                    <GovIcon />
                    <label
                      className={`text-[var(--abha-card-fg)]
                 text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
                    >
                      Government of India Initiative
                    </label>
                  </div>
                </div>
                {/* {white} */}
                <div className=" border border-[var(--abha-otp-bg)] h-full rounded-r-2xl px-[75px] w-[600px] flex flex-col gap-8 py-12">
                  <div className=" flex flex-col  gap-2 w-full ">
                    <label
                      className={`
                 text-[length:var(--abha-method-sub-title-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
                    >
                      Find Your ABHA
                    </label>
                    <label
                      className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
                    >
                      Enter your Mobile Number to find your existing ABHA
                    </label>
                  </div>

                  <div className="flex flex-col gap-8">
                    {/* Mobile Number Input */}
                    <div className="flex flex-col gap-2">
                      <InputPhoneField
                        // type="number"
                        errMsgContainerClass="hidden"
                        // maxLength={10}
                        labelClass={` text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name="mobile"
                        placeholder="Enter 10-digit mobile number"
                        label="Mobile Number"
                        isRequired={true}
                        containerClass="w-full h-min"
                      />
                      <label
                        className={`text-[var(--abha-nav-fg)] 
                               text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] `}
                      >
                        We'll send an OTP to verify your number
                      </label>
                    </div>

                    {/* Captcha Verification */}
                    <div className="flex flex-col gap-2">
                      <label
                        className={` text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-fw)] w-full`}
                      >
                        Verification{" "}
                        <span className="text-[var(--error-color)]">*</span>
                      </label>
                      {/* Math Question Display */}
                      <div className="flex items-center gap-4 p-4 bg-[var(--dashboard-bg-table-head)] rounded-lg border border-[var(--abha-otp-bg)]">
                        <span className="text-2xl  text-[var(--abha-method-card-title-fs)] font-[var(--abha-method-card-sub-title-fw)]">
                          {mathQuestion.question}
                        </span>
                        <button
                          type="button"
                          className="ml-auto p-2 text-[var(--abha-find-bg)] hover:bg-gray-100 rounded"
                          onClick={() => {
                            generateMathQuestion();
                            setFieldValue("verification", "");
                          }}
                          title="Generate new question"
                        >
                          <RefreshCw
                            size={18}
                            className="text-[var(--abha-reload-bg)]"
                          />
                        </button>
                      </div>
                      <InputField
                        type="number"
                        errMsgContainerClass="hidden"
                        maxLength={2}
                        labelClass="hidden"
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name="verification"
                        placeholder="Enter the answer"
                        isRequired={true}
                        containerClass="w-full h-min"
                      />
                      {verificationError && (
                        <label className="text-[var(--error-color)] text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)]">
                          {verificationError}
                        </label>
                      )}
                    </div>

                    {/* Action Button */}
                    <div className="flex flex-col gap-3 mt-4">
                      <AddButton
                        prefixIcon={false}
                        loading={loading}
                        onclkFn={() => handleShowErrorToast(errors)}
                        text={<span>Next</span>}
                        className="w-full
    justify-center items-center flex  px-3 py-4 whitespace-nowrap rounded-lg gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                        type="submit"
                      />
                      {/* <button
                          type="submit"
                          className="w-full py-3 px-4 bg-[var(--abha-find-bg)] text-white rounded-lg text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-title-fw)] hover:opacity-90 transition-opacity disabled:opacity-50"
                          onClick={() => {
                            if (
                              validateVerification() &&
                              values.mobile &&
                              values.mobile.length === 10
                            ) {
                              // Proceed with finding ABHA
                              console.log(
                                "Finding ABHA for mobile:",
                                values.mobile
                              );
                            }
                          }}
                        >
                          Find ABHA
                        </button> */}

                      <label
                        className={`text-center text-[var(--abha-nav-fg)] 
                               text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] `}
                      >
                        By continuing, you agree to ABHA Terms & Conditions
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex  justify-end  mt-auto mb-6 mr-6">
              <AddButton
                prefixIcon={false}
                text={"Cancel"}
                onclkFn={() => closeModal()}
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--trans-stats-con-red-fg)] cursor-pointer
    text-white
    text-[length:var(--draft-button-fs)] 
    font-[var(--draft-button-fw)]
    "
                type="button"
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

// function InputPage({ findABHApopup, setFindABHApopup }) {
//   const [method, setMethod] = useState("adhaar");
//   const [status, setStatus] = useState("Method Selection");
//   const [position, setPosition] = useState(0);
//   const [adhaarAccessToken, setAdhaarAccessToken] = useState("");
//   const [adhaarX_Token, setAdhaarX_Token] = useState("");

//   const [adhaarTokenExpiresIn, setAdhaarTokenExpiresIn] = useState("");
//   const [txnId, setTxnId] = useState("");
//   const [message, setmessage] = useState("");
//   const [drivingSuccessData, setDrivingSuccessData] = useState(null);
//   const [adhaarSuccessData, setAdhaarSuccessData] = useState(null);
//   const [newABHAaddress, setNewABHAaddress] = useState(null);

//   const [adhaarNo, setAdhaarNo] = useState("");

//   const closeModal = () => {
//     setFindABHApopup(false);
//   };

//   // Handle ESC key press
//   // useEffect(() => {
//   //   const handleEscape = (e) => {
//   //     if (e.key === "Escape" && findABHApopup) {
//   //       closeModal();
//   //     }
//   //   };

//   //   document.addEventListener("keydown", handleEscape);
//   //   return () => document.removeEventListener("keydown", handleEscape);
//   // }, [findABHApopup]);

//   // Prevent body scroll when modal is open
//   useEffect(() => {
//     if (findABHApopup) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }

//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, [findABHApopup]);

//   const handleOverlayClick = (e) => {
//     if (e.target === e.currentTarget) {
//       closeModal();
//     }
//   };
//   const initialValues = {
//     mobile: "",
//     verification: "",
//   };
//   return (
//     // <div
//     //   className="fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.7)] backdrop-blur-sm z-[2200]"
//     //   onClick={handleOverlayClick}
//     // >
//     <Formik
//       enableReinitialize
//       initialValues={initialValues}
//       // validationSchema={validationSchema}
//       // onSubmit={onsave}
//     >
//       {({
//         values,
//         setFieldValue,
//         resetForm,
//         setValues,
//         validateForm,
//         errors,
//       }) => (
//         <Form
//           className="fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.7)] backdrop-blur-sm z-[2200]"
//           onClick={handleOverlayClick}
//         >
//           <div className="bg-white w-[80%] h-[90%] rounded-lg flex flex-col overflow-hidden text-[var(--abha-fg)]">
//             <div className="flex justify-center items-center w-full h-full ">
//               <div className="flex flex-row gap-0 justify-center items-center w-full h-[80%] ">
//                 {/* {blue} */}
//                 <div className="flex flex-col w-[430px] rounded-l-2xl h-full  gap-5 p-10 bg-[var(--abha-find-bg)] text-white">
//                   {/* {top} */}

//                   <div className="flex flex-row  gap-4">
//                     <div className="flex flex-row">
//                       <div className="flex items-center justify-center w-11 h-[52px] rounded-lg bg-white">
//                         <HeartIcon />
//                       </div>
//                     </div>

//                     <div className=" flex flex-col  gap-2 w-full mt-auto ">
//                       <label
//                         className={`
//                  text-[length:var(--abha-method-sub-title-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
//                       >
//                         ABHA
//                       </label>
//                       <label
//                         className={`text-[var(--abha-card-fg)]
//                  text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
//                       >
//                         Ayushman Bharat Health Account
//                       </label>
//                     </div>
//                   </div>
//                   {/* {title} */}

//                   <label
//                     className={`
//                  text-[length:var(--abha-method-bold-fs)] font-[var(--abha-method-title-fw)] leading-[45px] mt-11 `}
//                   >
//                     Your Digital Health Identity
//                   </label>
//                   <label
//                     className={`text-[var(--abha-card-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-label-fw)] leading-[24px] `}
//                   >
//                     Create your unique health ID to access healthcare services
//                     across India. Secure, portable, and interoperable health
//                     records at your fingertips.
//                   </label>

//                   <div className="flex flex-col gap-4">
//                     <div className="flex flex-row gap-4">
//                       <TickIcon3 />
//                       <label
//                         className={`text-[var(--abha-card-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
//                       >
//                         Unified health records
//                       </label>
//                     </div>
//                     <div className="flex flex-row gap-4">
//                       <TickIcon3 />
//                       <label
//                         className={`text-[var(--abha-card-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
//                       >
//                         Secure data encryption
//                       </label>
//                     </div>{" "}
//                     <div className="flex flex-row gap-4">
//                       <TickIcon3 />
//                       <label
//                         className={`text-[var(--abha-card-fg)]
//                  text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
//                       >
//                         Easy healthcare access
//                       </label>
//                     </div>
//                   </div>
//                   <div className="flex flex-row gap-4 mt-9">
//                     <GovIcon />
//                     <label
//                       className={`text-[var(--abha-card-fg)]
//                  text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
//                     >
//                       Government of India Initiative
//                     </label>
//                   </div>
//                 </div>
//                 {/* {white} */}
//                 <div className=" border border-[var(--abha-otp-bg)] h-full rounded-r-2xl px-[75px] flex flex-col gap-8 py-12">
//                   <div className=" flex flex-col  gap-2 w-full ">
//                     <label
//                       className={`
//                  text-[length:var(--abha-method-sub-title-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
//                     >
//                       Find Your ABHA
//                     </label>
//                     <label
//                       className={`text-[var(--abha-nav-fg)]
//                  text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
//                     >
//                       Enter your Mobile Number to find your existing ABHA
//                     </label>
//                   </div>
//                   <div className="flex flex-col gap-2">
//                     <InputField
//                       type="number"
//                       errMsgContainerClass="hidden"
//                       maxLength={10}
//                       labelClass={` text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-fw)] w-full`}
//                       parentClass="flex  flex-col gap-2 w-full align-end "
//                       name="mobile"
//                       placeholder="Enter 10-digit mobile number"
//                       label="Mobile Number"
//                       //     defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]
//                       //   `}
//                       isRequired={true}
//                       containerClass="w-full h-min"
//                     />
//                     <label
//                       className={`text-[var(--abha-nav-fg)]
//                              text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] `}
//                     >
//                       We'll send an OTP to verify your number
//                     </label>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Form>
//       )}
//     </Formik>
//     // </div>
//   );
// }

export default InputPage;
